import { apiClient } from '../../api/client';
import type { components } from '../../api/generated/schema';
import { mapped } from '../errors';
import type { PhotoUploadRepository } from './ListingsRepository';
import { toPendingPhoto } from './mapping';

type S = components['schemas'];

/** The web's upload flow: a multipart POST per photo, before the listing exists. */
export const httpPhotoUploadRepository: PhotoUploadRepository = {
  upload: (file: File) =>
    mapped(async () => toPendingPhoto(await apiClient.pendingImageUpload(file))),
  list: () =>
    mapped(async () =>
      (await apiClient.get<S['PendingImage'][]>('/api/v1/pending-images/')).map(toPendingPhoto),
    ),
  delete: (id: string) => mapped(() => apiClient.pendingImageDelete(id)),
};
